"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcMeterReadings = void 0;
const UcMeterReadings_yaml_component_1 = __importDefault(require("./UcMeterReadings.yaml?component"));
exports.UcMeterReadings = UcMeterReadings_yaml_component_1.default;
